import React, { useState, useEffect } from 'react';
import { Phone, Mail, CheckCircle2 } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';

const ManageContact = () => {
  const [formData, setFormData] = useState({ phone: '', email: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const backendUrl = "https://www.sevaafoundation.com/seva-backend";
  const token = localStorage.getItem("sevaa_admin_token");

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${backendUrl}/api/settings/get_contact_info.php`);
        const data = await res.json();
        if (data.success) {
          setFormData(data.data);
        }
      } catch (error) {
        toast.error("Failed to load settings");
      } finally {
        setIsLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const loadingToast = toast.loading("Updating settings...");

    try {
      const response = await fetch(`${backendUrl}/api/settings/update_contact_info.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (data.success) {
        toast.success("Settings updated successfully!", { id: loadingToast });
      } else {
        toast.error(data.error || "Update failed", { id: loadingToast });
      }
    } catch (err) {
      toast.error("Server Error", { id: loadingToast });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-8 animate-fade-in-up pb-10">
      <Toaster position="top-right" />
      <div>
        <h1 className="text-3xl font-bold text-slate-800 flex items-center gap-3">
          <Phone className="text-orange-500" /> Site Contact Settings
        </h1>
        <p className="text-slate-500 mt-1">Update the public phone number and email address shown on the website.</p>
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 max-w-xl">
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-2 flex items-center gap-2">
                <Phone size={14} /> Helpline Number
              </label>
              <input
                required
                type="text"
                value={formData.phone}
                onChange={e => setFormData({ ...formData, phone: e.target.value })}
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="+91-99102 18596"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase mb-2 flex items-center gap-2">
                <Mail size={14} /> Official Email
              </label>
              <input
                required
                type="email"
                value={formData.email}
                onChange={e => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="info@sevaafoundation.com"
              />
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white font-bold py-3.5 rounded-xl transition-all flex justify-center gap-2"
            >
              <CheckCircle2 size={20} /> {isSubmitting ? 'Saving...' : 'Save Settings'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ManageContact;